export const CircleFlagEn = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <clipPath id="circle-clip-en">
        <circle cx="20" cy="20" r="14.375" />
      </clipPath>
      <g clipPath="url(#circle-clip-en)">
        {/* Blue background */}
        <rect x="5.625" y="5.625" width="28.75" height="28.75" fill="#012169" />
        {/* St Andrew's Cross (white diagonals) */}
        <line x1="5.625" y1="5.625" x2="34.375" y2="34.375" stroke="white" strokeWidth="4.8" />
        <line x1="34.375" y1="5.625" x2="5.625" y2="34.375" stroke="white" strokeWidth="4.8" />
        {/* St Patrick's Cross (red diagonals) */}
        <line x1="5.625" y1="5.625" x2="34.375" y2="34.375" stroke="#C8102E" strokeWidth="1.6" />
        <line x1="34.375" y1="5.625" x2="5.625" y2="34.375" stroke="#C8102E" strokeWidth="1.6" />
        {/* St George's Cross (white outline) */}
        <rect x="5.625" y="17.6" width="28.75" height="4.8" fill="white" />
        <rect x="17.6" y="5.625" width="4.8" height="28.75" fill="white" />
        {/* St George's Cross (red) */}
        <rect x="5.625" y="18.4" width="28.75" height="3.2" fill="#C8102E" />
        <rect x="18.4" y="5.625" width="3.2" height="28.75" fill="#C8102E" />
      </g>
      <circle cx="20" cy="20" r="14.375" fill="none" stroke="#e5e7eb" strokeWidth="0.5" />
    </svg>
  );
};
